import { CurrencyModel } from './currency.model';

export class NominalModel {
    public cod: string;
    public parent: string;
    public description: string;
    public leafs: number;
    public trading: string;
    public ccReq: string;
    public lft: number;
    public rgt: number;
    public currencyId: CurrencyModel;
}
